export const STRUCTURE = 'structure'
export const NAVIGATION = 'navigation'
export const ELEMENTS = 'elements'
export const CONTENT = 'content'